import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ButtonNamesGA, ModalNamesGA } from '@cpak/consts';
import { Router } from '@angular/router';
import { RoutingUrls } from '@cpak/enums';
import { PakType } from '@cpak/adp-cpak-notifications-service-models';
import { InAppNotification } from '@cpak/interfaces';
import { MODAL_NAME } from '@cpak/shared/injectors';

@UntilDestroy()
@Component({
  selector: 'cpak-notifications-popover',
  templateUrl: './notifications-popover.component.html',
  styleUrls: ['./notifications-popover.component.scss'],
  providers: [
    {
      provide: MODAL_NAME,
      useValue: ModalNamesGA.InAppNotifications,
    },
  ],
})
export class NotificationsPopoverComponent {
  @Input() notifications: InAppNotification[] = [];
  @ViewChild('overlayPanel') overlayPanel!: OverlayPanel;

  public readonly ButtonNamesGA = ButtonNamesGA;

  constructor(private router: Router) {}

  // TODO this method should be removed once this issue will be fixed https://github.com/primefaces/primeng/issues/13462
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const isClickOutsideOfPanel = !this.overlayPanel.container?.contains(event.target as Node);
    if (isClickOutsideOfPanel && this.overlayPanel.overlayVisible) {
      this.overlayPanel.hide();
    }
  }

  public navigateToPack(pakId: string, pakType: PakType): void {
    if (pakType === PakType.quote) {
      this.router.navigate([RoutingUrls.Quotes, pakId]);
    }
    if (pakType === PakType.prototype) {
      this.router.navigate([RoutingUrls.Prototypes, pakId]);
    }
    this.overlayPanel.hide();
  }
}
